import React, { useState } from "react";
import { db, storage } from "../firebaseConfig"; // Ensure the correct paths
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { getAuth } from "firebase/auth";

const GiveUsYourCarForm = () => {
  const [formData, setFormData] = useState({
    carName: "",
    year: "",
    mileage: "",
    price: "",
    location: "",
    contactName: "",
    contactEmail: "",
    contactPhone: "",
  });

  const [pictures, setPictures] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setPictures([...e.target.files]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      alert("You must be logged in to submit this form.");
      return;
    }

    const userID = user.uid;

    try {
      // Upload pictures and get their URLs
      const pictureURLs = [];
      for (const picture of pictures) {
        const pictureRef = ref(storage, `forms/${formData.carName}/${picture.name}`);
        const uploadTask = uploadBytesResumable(pictureRef, picture);

        await new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              setUploadProgress(progress);
            },
            (error) => {
              console.error("Upload failed:", error);
              reject(error);
            },
            async () => {
              const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
              pictureURLs.push(downloadURL);
              resolve();
            }
          );
        });
      }

      // Save form data to Firestore
      await addDoc(collection(db, "forms"), {
        userID,
        details: formData,
        pictures: pictureURLs,
        createdAt: Timestamp.now(),
      });

      alert("Thank you for submitting your car! We'll get in touch soon.");
      setFormData({
        carName: "",
        year: "",
        mileage: "",
        price: "",
        location: "",
        contactName: "",
        contactEmail: "",
        contactPhone: "",
      });
      setPictures([]);
      setUploadProgress(0);
    } catch (error) {
      console.error("Error submitting car:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div style={{ maxWidth: "800px", margin: "20px auto", padding: "20px", backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
      <h1 style={{ textAlign: "center", marginBottom: "20px", color: "#007bff" }}>Submit Your Car</h1>

      {/* Note */}
      <p style={{ textAlign: "center", color: "#333", marginBottom: "20px", }}>
        Want to sell your car or list a personal vehicle? Enter information about your car and we will contact you soon.
      </p>

      <form onSubmit={handleSubmit}>
        {Object.keys(formData).map((field) => (
          <div style={{ marginBottom: "15px" }} key={field}>
            <label
              htmlFor={field}
              style={{ display: "block", fontWeight: "bold", marginBottom: "5px", color: "black" }}
            >
              {field
                .replace(/([A-Z])/g, " $1")
                .replace(/^(.)/, (str) => str.toUpperCase())}
            </label>
            <input
              id={field}
              name={field}
              type={field === "price" || field === "year" || field === "mileage" ? "number" : "text"}
              value={formData[field]}
              onChange={handleInputChange}
              placeholder={`Enter ${field}`}
              style={{ width: "95%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc" }}
              required
            />
          </div>
        ))}

        {/* Pictures */}
        <div style={{ marginBottom: "15px" }}>
          <label htmlFor="pictures" style={{ display: "block", fontWeight: "bold", marginBottom: "5px", color: "black" }}>
            Upload Pictures:
          </label>
          <input
            id="pictures"
            type="file"
            multiple
            onChange={handleFileChange}
            style={{ width: "100%", padding: "10px" }}
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: "#007bff",
            color: "#fff",
            fontWeight: "bold",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer",
          }}
        >
          Submit Your Car
        </button>
      </form>
    </div>
  );
};

export default GiveUsYourCarForm;
